import { z } from 'zod';
import { PromiseStatus } from './promise.js';
/**
 * A feature that must exist before a legacy customer can be migrated to
 * Waypoint. Mirrors CustomerPromise (same status lifecycle, same progress
 * rollup from linked tickets) but tracks migration gates instead of sales
 * commitments — the two are deliberately separate entities so onboarding
 * (new customers) and migration (existing customers) never mix.
 *
 * `createdAt` is the "added on" date; `targetDate` is an optional target
 * completion date. `ticketCount`/`doneTicketCount`/`progressPct`/`overdue`
 * are derived rollups, present on reads.
 */
export const MigrationBlocker = z.object({
    id: z.string(),
    customerId: z.string(),
    customerName: z.string().nullable(), // resolved on reads (handy for the global list)
    title: z.string(),
    description: z.string().nullable(),
    status: PromiseStatus,
    targetDate: z.string().nullable(), // ISO date (optional)
    createdAt: z.string(),
    updatedAt: z.string(),
    // Progress rollup (progress.ts): linked tickets minus cancelled/rejected ones.
    ticketCount: z.number().optional(),
    doneTicketCount: z.number().optional(),
    progressPct: z.number().optional(), // 0-100, mean status weight of those tickets
    blockedTicketCount: z.number().optional(), // linked tickets flagged blocked
    overdue: z.boolean().optional(),
});
export const CreateMigrationBlockerInput = z.object({
    title: z.string().min(1).max(300),
    description: z.string().optional(),
    status: PromiseStatus.optional(),
    targetDate: z.string().optional(), // ISO date (optional)
});
export const UpdateMigrationBlockerInput = CreateMigrationBlockerInput.partial().extend({
    // Nullable so the target date can be CLEARED via edit.
    targetDate: z.string().nullable().optional(),
    // Full-replace set of tickets linked to this blocker (accepts ids or codes).
    // [] unlinks all. Reconciled against Ticket.blockerId server-side.
    ticketIds: z.array(z.string()).optional(),
});
//# sourceMappingURL=migration.js.map